// extracted by mini-css-extract-plugin
module.exports = {"addressText":"AddressText_addressText__EILH6"};